import apiService from 'apiService';
import printJS from 'print-js';
import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas'

export default function FormConsent() {
    const sigCanvas = useRef({});
    const { pathname } = useLocation();
    const path = pathname.split('/');
    const dt = JSON.parse(atob(path[2]));
    const clear = () => {
        setparam({ ...param, ttd: '' });
        sigCanvas.current.clear()
    };
    const [imageURL, setImageURL] = useState(null);
    const [param, setparam] = useState({
        name: dt?.px?.name ? `${dt?.px?.name} ${dt?.px?.last_name}` : '',
        address: dt?.px?.address ? dt?.px?.address : '',
        contact: dt?.px?.contact ? dt?.px?.contact : '',
        nik: dt?.px?.nik ? dt?.px?.nik : '',
        nik_pasien: dt?.px?.nik ? dt?.px?.nik : '',
        family: 'diri sendiri',
        status: true,
        worker: dt.worker ?? '',
        puskesmas: dt.puskesmas ?? '',
        px: dt.px ?? '',
        ttd: ''
    }) // create a state that will contain our image url
    const save = async () => {
        const par = {
            ...param,
            ttd: imageURL
        }
        if (!par.ttd) {
            alert('ttd tidak boleh kosong')
        } else {
            let res = await apiService.post('/link/gc_post', { par })
            if (res) {
                alert('berhasil');

            } else {
                alert('gagal simpan')
            }
        }
    }
    useEffect(() => {
        if (imageURL != '') {
            save()
        }
    }, [imageURL])


    return (
        <div className='card'>
            <div className='card-body'>
                <div style={{ width: '100%', alignContent: "center", borderWidth: 2 }}>
                    <div> PERSETUJUAN UMUM PASIEN RAWAT JALAN </div>
                </div>
                <br />
                <div>
                    Saya yang bertanda tangan dibawah ini:
                </div>

                <table>
                    <tbody>
                        <tr>
                            <td>
                                Nama
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                <input
                                    className="form-control form-control-sm col-md-12"
                                    type="text"
                                    placeholder="nama"
                                    id="name"
                                    name="name"
                                    value={param.name}
                                    onChange={(e) => setparam({ ...param, [e.target.name]: e.target.value })}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Alamat
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                <textarea
                                    className="form-control form-control-sm"
                                    style={{ minWidth: 200 }}
                                    type="text"
                                    placeholder="alamat"
                                    value={param.address}
                                    name='address'
                                    onChange={(e) => setparam({ ...param, [e.target.name]: e.target.value })}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                No. Telp
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                <input
                                    className="form-control form-control-sm col-md-12"
                                    type="text"
                                    placeholder="contact"
                                    id="contact"
                                    name="contact"
                                    value={param.contact}
                                    onChange={(e) => setparam({ ...param, [e.target.name]: e.target.value })}

                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                No. KTP/SIM/Paspor
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                <input
                                    className="form-control form-control-sm col-md-12"
                                    type="text"
                                    placeholder="ktp"
                                    id="nik"
                                    name="nik"
                                    value={param.nik}
                                    onChange={(e) => setparam({ ...param, [e.target.name]: e.target.value })}

                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Hub. Dengan Pasien
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                <input
                                    className="form-control form-control-sm col-md-12"
                                    type="text"
                                    placeholder="ayah/ibu/kakak/saudara"
                                    id="family"
                                    name="family"
                                    value={param.family}
                                    onChange={(e) => setparam({ ...param, [e.target.name]: e.target.value })}


                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Bertanggung jawab atas pasien :
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Nama
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                {dt?.px?.name ? `${dt?.px?.name} ${dt?.px?.last_name}` : ''}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Alamat
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                {dt?.px?.address ? `${dt?.px?.address}` : ''}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Tanggal Lahir
                            </td>
                            <td>
                                :
                            </td>
                            <td>
                                {dt?.px?.birth_date ? `${dt?.px?.birth_date}` : ''}
                            </td>
                        </tr>
                        <tr>
                            <td> Dengan ini menyatakan bahwa:</td>
                        </tr>
                    </tbody>
                </table>
                <table border={1} >
                    <tbody>
                        <tr>
                            <th>No</th>
                            <th>Jenis Informasi</th>
                        </tr>
                        <tr>
                            <th colspan="2">Informasi Hak dan Kewajiban Pasien</th>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>Saya mengetahui bahwa saya memiliki kondisi yang membutuhkan perawatan medis, saya mengizinkan dokter/tenaga kesehatan lainnya di {dt.puskesmas.name}, untuk melakukan pemeriksaan dan memeberikan pengobatan / tindakan / asuhan sesuai prosedur.</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Saya sadar bahwa praktik kedokteran bukanlah ilmu pasti dan saya mengakui bahwa tidak ada jaminan atas hasil apapun terhadap prosedur pengobatan/asuhan/tindakan lainnya yang dilakukan terhadap saya</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Saya mengerti dan memahami bahwa : </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>a. Saya memiliki hak untuk menyatakan persetujuan atau menolak setiap prosedur atau terapi yang akan diberikan kepada saya</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>b. Saya memiliki hak untuk mengajukan pertanyaan tentang rencana pelayanan yang akan diberikan kepada saya, termasuk identitas setiap orang yang akan memberikan pelayanan pemeriksaan / tindakan kepada saya</td>
                        </tr>
                        <tr>
                            <th colspan="2">Persetujuan Perawatan dan Pengobatan</th>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Saya bersedia untuk dilakukan pemeriksaan, prosedur diagnostik, perawatan, dan pengobatan di {dt.puskesmas.name} oleh dokter, dokter gigi, dan tenaga kesehatan lainnya.</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Jika saya memutuskan untuk menghentikan perawatan medis untuk diri saya sendiri, saya menyadari dan memahami bahwa {dt.puskesmas.name} atau dokter dari {dt.puskesmas.name} tidak bertanggungjawab atas hasil yang merugikan saya.</td>
                        </tr>
                        <tr>
                            <th colspan="2">Penjelasan Persetujuan Risiko Tinggi</th>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Saya mengerti bahwa apabila diperlukan pemeriksaan/ tindakan/ pengobatan yang berisiko tinggi, makaakan dilakukan pemberian persetujuan/ penolakan dengan menggunakan formulir khusus (<i>informed consent</i>).</td>
                        </tr>
                        <tr>
                            <th colspan="2">Pelepasan Informasi Kesehatan</th>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>Saya bersedia memberi kuasa kepada {dt.puskesmas.name} untuk memberikan informasi kesehatan tentang diri saya bila diperlukan untuk proses klaim asuransi/ perusahaan sesuai peraturan yang berlaku.</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>
                                Saya mengetahui dan menyetujui bahwa berdasarkan Peraturan Menteri Kesehatan Nomor 24 Tahun 2022 tentang Rekam Medis, fasilitas pelayanan kesehatan wajib membuka akses dan mengirim data rekam medis kepada Kementerian Kesehatan melalui Platform SATUSEHAT.
                            </td>
                        </tr>
                        <tr>
                            <td>9</td>
                            <td>
                                <label className="custom-toggle custom-toggle-success">
                                    <input
                                        type="checkbox"
                                        checked={
                                            param.status == true
                                                ? "checked"
                                                : ""
                                        }
                                        onChange={(e) => setparam({ ...param, status: e.target.checked })}
                                    />
                                    <span
                                        className="custom-toggle-slider rounded-circle"
                                        data-label-off="F"
                                        data-label-on="T"
                                    />
                                </label> {param.status ? 'Menyetujui' : 'Tidak Menyetujui'} untuk menerima dan membuka data Pasien dari Fasilitas Pelayanan Kesehatan lainnya melalui SATUSEHAT untuk kepentingan pelayanan kesehatan dan/atau rujukan.
                            </td>
                        </tr>
                        <tr>
                            <th colspan="2">Tanggung Jawab terhadap Barang Milik Pasien</th>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>Saya bertanggung jawab terhadap barang-barang milik saya/ pasien maupun keluarga pasien.</td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ marginTop: 15 }}>
                    <div>Tanda tangan <button className='btn btn-sm btn-info ml-5' onClick={() => clear()}>clear</button></div>
                    <div style={{ padding: 5, backgroundColor: 'grey', width: 350, }}>
                        <div style={{ backgroundColor: 'white', width: 320, }}>
                            <SignatureCanvas
                                ref={sigCanvas}
                                penColor='black'
                                canvasProps={{ width: 300, height: 200 }} />
                        </div>
                    </div>
                </div>
                <div>
                    <button className='btn btn-primary mt-2' onClick={() => setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"))
                    }> selesai </button>
                </div>
            </div>
        </div>
    )
}
